(function () {
  var SCROLL_TRIGGER = 40;

  function init(root) {
    var header = root.querySelector('[data-cuoio-header]');
    if (!header || header.dataset.cuoioReady === 'true') return;
    header.dataset.cuoioReady = 'true';

    var burger = header.querySelector('[data-cuoio-burger]');
    var panel = header.querySelector('[data-cuoio-panel]');
    var sticky = header.dataset.sticky === 'true';

    // Publish the measured height so sections can offset against it.
    function measure() {
      document.documentElement.style.setProperty('--cu-hd-h', header.offsetHeight + 'px');
    }

    function onScroll() {
      var past = window.scrollY > SCROLL_TRIGGER;
      header.classList.toggle('is-scrolled', past);
      if (!sticky) header.classList.toggle('is-hidden', past);
    }

    function closePanel() {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function togglePanel() {
      if (!panel) return;
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      burger.setAttribute('aria-expanded', String(willOpen));
      header.classList.toggle('is-open', willOpen);
      document.body.style.overflow = willOpen ? 'hidden' : '';
    }

    if (burger) burger.addEventListener('click', togglePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    // Desktop layout has its own nav, so a panel left open would be orphaned.
    var desktop = window.matchMedia('(min-width: 900px)');
    var onBreakpoint = function (e) {
      if (e.matches) closePanel();
    };
    desktop.addEventListener('change', onBreakpoint);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);

    measure();
    onScroll();

    header._cuoioTeardown = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', measure);
      desktop.removeEventListener('change', onBreakpoint);
      document.body.style.overflow = '';
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    var header = e.target.querySelector('[data-cuoio-header]');
    if (header && header._cuoioTeardown) header._cuoioTeardown();
  });
})();